module.exports = __webpack_public_path__ + "static/media/tag-logo.29516afc.svg";